import { Injectable } from '@angular/core';
import { ActionSheetController } from '@ionic/angular';
import { ActionSheetButton } from '@ionic/core';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { TranslateService } from '@ngx-translate/core';
import { Tool } from '@services/tools';

@Injectable()
export class MediaToolsProviderService {
  private readonly _mediaTools: Tool[] = [];
  get mediaTools(): Tool[] {
    return this._mediaTools;
  }

  constructor(private actionSheetController: ActionSheetController, private translate: TranslateService) {}

  register(mediaTool: Tool) {
    this._mediaTools.push(mediaTool);
  }

  openTools(callcard: CallCard): Promise<void> {
    const actionSheetButtons = this._mediaTools.map(tool => this.createButton(tool, callcard));
    return this.actionSheetController
      .create({ header: this.translate.instant('Saga.AttachmentsType'), buttons: actionSheetButtons })
      .then(actionSheet => actionSheet.present());
  }

  private createButton(tool: Tool, callcard: CallCard): ActionSheetButton {
    return {
      text: this.translate.instant(tool.text),
      role: tool.text,
      handler: () => tool.handler({ callcard: callcard })
    };
  }
}
